import React from 'react'
import { Link } from 'react-router-dom'

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb'

interface Step {
  label: string
  to: string | (() => string)
}

interface AppBreadcrumbsProps {
  steps: Step[]
}
export const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ steps }) => {
  return (
    <Breadcrumb>
      <BreadcrumbList className='text-xs'>
        {steps.map((step, idx, arr) => (
          <React.Fragment key={idx}>
            <BreadcrumbItem>
              {idx !== arr.length - 1 ? (
                <BreadcrumbLink asChild>
                  <Link to={typeof step.to === 'function' ? step.to() : step.to}>{step.label}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{step.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {idx !== arr.length - 1 && <BreadcrumbSeparator>/</BreadcrumbSeparator>}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
